export default __webpack_public_path__ + "tmp_src/components/ImageComparison/ImageComparison.css.liquid";